import {
  createBookRequest,
  createBookRequestComment,
  deleteBookRequest,
  deleteBookRequestComment,
  fetchBookRequestComments,
  fetchBookRequests,
  setBookRequestCommentLike,
  setBookRequestLike,
} from '../apis/bookRequest';
import type { BookRequest, BookRequestComment, BookRequestFeed } from '../types/bookRequest.types';
import {
  type CommunityBoard,
  useCommunityComments,
  useCommunityPages,
  useCreateCommunityComment,
  useCreateCommunityPost,
  useDeleteCommunityComment,
  useDeleteCommunityPost,
  useLikeCommunityComment,
  useLikeCommunityPost,
} from './useCommunityBoard';

// Calls go through the module at call time (the tests mock only what they use)
const BOOK_REQUESTS: CommunityBoard<BookRequest, BookRequestComment, string> = {
  feedsKey: 'book-requests',
  commentsKey: 'book-request-comments',
  fetchPosts: (feed, page, size) => fetchBookRequests(feed, page, size),
  createPost: (content) => createBookRequest(content),
  deletePost: (postId) => deleteBookRequest(postId),
  setPostLike: (postId, liked) => setBookRequestLike(postId, liked),
  fetchComments: (postId, page, size) => fetchBookRequestComments(postId, page, size),
  createComment: (postId, content) => createBookRequestComment(postId, content),
  deleteComment: (postId, commentId) => deleteBookRequestComment(postId, commentId),
  setCommentLike: (postId, commentId, liked) => setBookRequestCommentLike(postId, commentId, liked),
};

/** Timeline or Postingan Saya pages. */
export const useBookRequestPages = (feed: BookRequestFeed) =>
  useCommunityPages(BOOK_REQUESTS, feed);

/** Every comment of a post, oldest first; nothing is requested until `enabled`. */
export const useBookRequestComments = (postId: string, enabled: boolean) =>
  useCommunityComments(BOOK_REQUESTS, postId, enabled);

export const useCreateBookRequest = () => useCreateCommunityPost(BOOK_REQUESTS);
export const useDeleteBookRequest = () => useDeleteCommunityPost(BOOK_REQUESTS);
export const useLikeBookRequest = () => useLikeCommunityPost(BOOK_REQUESTS);
export const useCreateBookRequestComment = () => useCreateCommunityComment(BOOK_REQUESTS);
export const useDeleteBookRequestComment = () => useDeleteCommunityComment(BOOK_REQUESTS);
export const useLikeBookRequestComment = () => useLikeCommunityComment(BOOK_REQUESTS);
